export const COMPANY = {
  API_BASE_URL : "https://api.optionbricks.in",
  NAME: "Optionbricks",
  SHORT_NAME: "Optionbricks",
  SEBI_REG_NO: "INH000017408 ",
  SEBI_REG_DATE: "Mar 19, 2024",

  ADDRESS:
    "Renuka Shobha Fl 604 Sno., Chinchwad, Chindhwadgaon, Mulshi, Pune, Maharashtra, 411033",

  CONTACT: {
    PHONE: "919082280240",
    EMAIL: "support@optionbricks.in",
  },

  FEES: {
    MAX_PER_YEAR: "₹1.51 lakhs",
  },

  LINKS: {
    SCORES: "https://scores.sebi.gov.in",
    SMART_ODR: "https://smartodr.in",
  },
};
